import {
  getUrl,
  PersonPopover,
} from "@amzn/squad-front-end-shared-react-components";
import React from "react";
import { EmployeeDto } from "@amzn/squad-front-end-shared-react-components/dist/components/popover/personpopover/get-employee-response.dto";
import { MetricsState } from "../../logging";
import { TeamDto } from "../../common/model/team.dto";
import { KeyValuePairs } from "@amzn/awsui-components-react-v3";

interface TeamInformationsProps {
  team: TeamDto;
  ownerName?: string;
  metrics: MetricsState;
  employeeData?: EmployeeDto;
  isCurrentUserAuthorized?: boolean;
}

const TeamInformations: React.FC<TeamInformationsProps> = ({
  team,
  ownerName: owner,
  metrics,
  employeeData,
  isCurrentUserAuthorized,
}): JSX.Element => {
  const emptyValueLabel = "Click edit to add";

  return (
    <KeyValuePairs
      items={[
        {
          label: "Team name",
          value: team.name,
        },
        {
          label: "Team owner",
          value: team.owner ? (
            <div>
              <PersonPopover
                position="bottom"
                metrics={metrics}
                triggerType={"custom"}
                popoverTrigger={<div>{owner}</div>}
                rosterBaseUrl={getUrl("roster2", true)}
                employeeData={employeeData}
              />
            </div>
          ) : (
            <div>
              {(isCurrentUserAuthorized &&
                `${emptyValueLabel} a team owner.`) ||
                "-"}
            </div>
          ),
        },
        {
          label: "Team description",
          value:
            team.description ||
            (isCurrentUserAuthorized && `${emptyValueLabel} a description.`) ||
            "-",
        },
        {
          label: "Team charter",
          value:
            team.charter ||
            (isCurrentUserAuthorized && `${emptyValueLabel} a charter.`) ||
            "-",
        },
        {
          label: "Team tenets",
          value:
            team.tenets ||
            (isCurrentUserAuthorized && `${emptyValueLabel} tenets.`) ||
            "-",
        },
      ]}
    />
  );
};

export default TeamInformations;
